import { render } from "./CreateNetworkPermission.vue?vue&type=template&id=7c89927e&scoped=true"
import script from "./CreateNetworkPermission.vue?vue&type=script&lang=js"
export * from "./CreateNetworkPermission.vue?vue&type=script&lang=js"

import "./CreateNetworkPermission.vue?vue&type=style&index=0&id=7c89927e&lang=less&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c89927e"]])

export default __exports__